import React from 'react';
import { Paper, Group, Stack, Text, Box } from '@mantine/core';

type ReportCardProps = {
    value: string | number;
    label: string;
    icon: React.ReactNode;
    iconBgClass?: string;
    iconColorClass?: string;
};

function ReportCard({
    value,
    label,
    icon,
    iconBgClass = 'bg-[#FEF3E2]',
    iconColorClass = 'text-[#F97316]',
}: ReportCardProps) {
    return (
        <Paper
            p="md"
            shadow="sm"
            radius="lg"
            withBorder
            className="min-w-[260px] border-gray-100"
        >
            <Group gap="xs" align="center" wrap="nowrap">
                <Box
                    className={`w-12 h-12 rounded-2xl flex items-center justify-center shrink-0 ${iconBgClass} ${iconColorClass}`}
                >
                    {icon}
                </Box>
                <Stack gap="xs">
                    <Text className="text-gray-800 text-4xl font-bold leading-none">
                        {value}
                    </Text>
                    <Text className="text-gray-500 text-sm font-medium">
                        {label}
                    </Text>
                </Stack>
            </Group>
        </Paper>
    );
}

export default ReportCard;
